// @ts-expect-error - No declaration is required - TODO: - Stop using when the project is migrated.
import { REACT_APP_BACKEND_URL } from "@env";
import axios from "axios";

const HttpClient = axios.create({
  baseURL: REACT_APP_BACKEND_URL as string,
});

export { HttpClient };
